module.exports = "<td>{{ titulo }}</td>\n<td width=\"100px\">\n\t<select name=\"porcao_id\">\n\t\t{% for porcao in porcoes %}\n\t\t\t<option value=\"{{ porcao.id }}\" {% if porcao.id == Porcao.id %}selected{% endif %}>{{ porcao.titulo }}</option>\n\t\t{% endfor %}\n\t</select>\n</td>\n<td width=\"100px\"><span class=\"calorias\"></span>Kcal</td>\n<td width=\"100px\">R$<span class=\"valor\"></span></td>\n<td width=\"50px\"><a href=\"javascript:void(0)\" class=\"add-product\" title=\"Adicionar produto\"><i class=\"fa fa-plus-square\" aria-hidden=\"true\"></i></a></td>"


//////////////////
// WEBPACK FOOTER
// ./views/kits/dialog-cardapio/tr-produto.twig
// module id = 48
// module chunks = 0